import { useThemePreference } from "@src/features/theme";

import { PreferencesSettingsPageV2 } from "../../../ui/pages/v2";

export function PreferencesSettingsV2Route() {
  const {
    effectiveColorScheme,
    setThemePreference,
    systemColorScheme,
    themePreference,
  } = useThemePreference();

  return (
    <PreferencesSettingsPageV2
      effectiveColorScheme={effectiveColorScheme}
      onThemePreferenceChange={setThemePreference}
      systemColorScheme={systemColorScheme}
      themePreference={themePreference}
    />
  );
}
